import MuiIconButton from "@mui/material/IconButton";
import { getIconButtonStyles } from "./IconButton.styles";
import styles from "./IconButton.module.scss";

export interface IconButtonProps {
  iconName: string;
  onClick: () => void;
  color: "primary" | "secondary" | "text";
  variant?: "text" | "contained";
  disabled?: boolean;
}

function IconButton(props: IconButtonProps) {
  const {
    iconName,
    onClick,
    color,
    disabled = false,
    variant = "contained",
  } = props;
  const IconButtonStyles = getIconButtonStyles(color, variant);
  return (
    <MuiIconButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        ...IconButtonStyles,
        padding: "0.125rem",
        "&:focus": {
          outline: "none",
        },
      }}
      className={styles.iconButton}
      disableRipple
    >
      <i className={`${iconName}`} />
    </MuiIconButton>
  );
}

export default IconButton;
